export default __webpack_public_path__ + "6b6b2effda9f78d2623bf519228639dd.png";